module.exports = __webpack_public_path__ + "img/menu_btn.243d08ca.png";